import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import galleryData from "../data/newgallery.json";
import "../styles/gallerypage.css";
import seoFriendlySlug from "../utils/seoFriendlySlug";

const Gallerydetail = () => {
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [fullscreenVideo, setFullscreenVideo] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);

  const handleImageClick = (src, index) => {
    setFullscreenImage(src);
    setCurrentImageIndex(index);
  };

  const handleVideoClick = (src, index) => {
    setFullscreenVideo(src);
    setCurrentVideoIndex(index);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
    setCurrentImageIndex(null);
    setFullscreenVideo(null);
    setCurrentVideoIndex(null);
  };
  const { categoryName } = useParams();
  const [category, setCategory] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (fullscreenImage) {
        if (event.key === "ArrowRight") {
          setCurrentImageIndex((prevIndex) => {
            const nextIndex =
              prevIndex === null
                ? 0
                : (prevIndex + 1) %
                  category.subheadings.flatMap((sub) => sub.media.images)
                    .length;
            setFullscreenImage(
              getMediaUrl(
                category.subheadings.flatMap((sub) => sub.media.images)[
                  nextIndex
                ]
              )
            );
            return nextIndex;
          });
        } else if (event.key === "ArrowLeft") {
          setCurrentImageIndex((prevIndex) => {
            const prevIndexCalc =
              prevIndex === null
                ? 0
                : (prevIndex -
                    1 +
                    category.subheadings.flatMap((sub) => sub.media.images)
                      .length) %
                  category.subheadings.flatMap((sub) => sub.media.images)
                    .length;
            setFullscreenImage(
              getMediaUrl(
                category.subheadings.flatMap((sub) => sub.media.images)[
                  prevIndexCalc
                ]
              )
            );
            return prevIndexCalc;
          });
        }
      }
      if (fullscreenVideo) {
        if (event.key === "ArrowRight") {
          setCurrentVideoIndex((prevIndex) => {
            const nextIndex =
              prevIndex === null
                ? 0
                : (prevIndex + 1) %
                  category.subheadings.flatMap((sub) => sub.media.videos)
                    .length;
            setFullscreenVideo(
              getMediaUrl(
                category.subheadings.flatMap((sub) => sub.media.videos)[
                  nextIndex
                ]
              )
            );
            return nextIndex;
          });
        } else if (event.key === "ArrowLeft") {
          setCurrentVideoIndex((prevIndex) => {
            const prevIndexCalc =
              prevIndex === null
                ? 0
                : (prevIndex -
                    1 +
                    category.subheadings.flatMap((sub) => sub.media.videos)
                      .length) %
                  category.subheadings.flatMap((sub) => sub.media.videos)
                    .length;
            setFullscreenVideo(
              getMediaUrl(
                category.subheadings.flatMap((sub) => sub.media.videos)[
                  prevIndexCalc
                ]
              )
            );
            return prevIndexCalc;
          });
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [fullscreenImage, fullscreenVideo, category]);

  useEffect(() => {
    if (galleryData && galleryData.gallery) {
      const selectedCategory = galleryData.gallery.find(
        (cat) => seoFriendlySlug(cat.heading) === seoFriendlySlug(categoryName)
      );
      setCategory(selectedCategory);
    } else {
      console.error("galleryData.gallery is undefined or invalid.");
    }
  }, [categoryName]);



  const getMediaUrl = (mediaPath) => {
    const baseUrl = "https://timewatch.co.in/gallery/";  // Prepend this base URL to the image path
    return baseUrl + mediaPath;  // Returns the full URL for the image
  };

  if (!category) {
    return <div>Loading...</div>;
  }

  return (
    <div className="gallery-page">
      <button onClick={() => navigate(-1)} className="back-button" style={{cursor: "pointer"}}>
        ← Back to Gallery
      </button>

      <h1 className="gallery-heading">{category.heading}</h1>

      {category.subheadings.map((subheadingData, subIndex) => (
        <div key={subIndex}>
          <h3 className="subheading">{subheadingData.subheading}</h3>

          {}
          <div className="media-section">
            <h2 className="media-title">Images</h2>
            <div className="media-grid">
              {subheadingData.media.images.map((image, index) => {
                const imageUrl = getMediaUrl(image);
                return (
                  <div key={index} className="media-card">
                    {" "}
                    {}
                    <img
                      src={imageUrl}
                      alt={`Gallery Image ${index + 1}`}
                      className="media-image"
                      onClick={() => handleImageClick(imageUrl, index)}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          {fullscreenImage && (
            <div className="fullscreen-overlay" onClick={closeFullscreen}>
              <img
                src={fullscreenImage}
                alt="Fullscreen"
                className="fullscreen-image"
              />
            </div>
          )}

          {}
          {subheadingData.media.videos.length > 0 && (
            <div className="media-section">
              <h2 className="media-title">Videos</h2>
              <div className="media-grid">
                {subheadingData.media.videos.map((video, index) => {
                  const videoUrl = getMediaUrl(video);
                  return (
                    <div
                      key={index}
                      className="media-card"
                      onClick={() => handleVideoClick(videoUrl, index)}
                    >
                      <video src={videoUrl} controls className="media-video">
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  );
                })}
              </div>
              {}
              {fullscreenVideo && (
                <div className="fullscreen-overlay" onClick={closeFullscreen}>
                  <video
                    src={fullscreenVideo}
                    controls
                    autoPlay
                    className="fullscreen-video"
                  />{" "}
                  {}
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Gallerydetail;
